// extracted by mini-css-extract-plugin
export default {"custom-chip":"CustomChip_custom-chip__zYzmp","delete-btn":"CustomChip_delete-btn__qJbLU"};